/**
 * 路径按 App 里 RoundedStar 的算法逐点生成（points 5 / innerRatio .54 / rounding .86），
 * 不是随便找的星形——那颗手画的胖圆角星是这个产品最好认的一个形状。
 */
const STAR_PATH = 'M13.638 2.906L14.171 3.852Q15.809 6.758 19.078 7.417L20.143 7.632Q23.413 8.292 '
  + '21.155 10.747L20.42 11.547Q18.163 14.002 18.546 17.316L18.67 18.395Q19.053 21.708 16.02 '
  + '20.32L15.033 19.868Q12 18.48 8.967 19.868L7.98 20.32Q4.947 21.708 5.33 18.395L5.454 '
  + '17.316Q5.837 14.002 3.58 11.547L2.845 10.747Q0.587 8.292 3.857 7.632L4.922 7.417Q8.191 '
  + '6.758 9.829 3.852L10.362 2.906Q12 0 13.638 2.906Z';

export function StarLogo({ size = 22, color = '#ffb85f' }: { size?: number; color?: string }) {
  return (
    <svg
      className="star-logo"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
    >
      <path d={STAR_PATH} />
    </svg>
  );
}

export function CloseIcon({ size = 12 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}

export function NoteIcon({ size = 17, color = 'currentColor' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden="true">
      <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
    </svg>
  );
}
